// controllers/qrcode_controller.js
import { Controller } from "@hotwired/stimulus"
import QRCodeStyling from "qr-code-styling"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    url: String,
    size: { type: Number, default: 224 },
    logo: String,                               // <-- URL or data URL
    renderer: { type: String, default: "canvas" }
  }

  connect() {
    this.qr = new QRCodeStyling({
      width: this.sizeValue,
      height: this.sizeValue,
      type: this.rendererValue,
      data: this.urlValue || window.location.href,
      margin: 0,
      qrOptions: { typeNumber: 0, mode: "Byte", errorCorrectionLevel: "Q" },
      dotsOptions: { type: "square", color: "#000000", roundSize: true },
      backgroundOptions: { color: "#ffffff" },
      image: this.logoValue || undefined,       // <-- URL here
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 9,
        crossOrigin: "anonymous"                // important for canvas + export
      },
      cornersSquareOptions: { type: "extra-rounded", color: "#000000" },
      cornersDotOptions: { type: "dot", color: "#000000" }
    })
    this.containerTarget.innerHTML = ""
    this.qr.append(this.containerTarget)
  }
}
